import type { App } from 'vue'
import { createHead } from '@unhead/vue'

export function head(app: App) {
  const head = createHead()

  app.use(head)
}
